interface CoffeeBeanProps {
  size: number;
  opacity: number;
  rotate: number;
}

export function CoffeeBean({ size, opacity, rotate }: CoffeeBeanProps) {
  return (
    <div
      className="relative"
      style={{
        width: size,
        height: size * 0.7,
        opacity,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <div
        className="rounded-full"
        style={{
          width: "100%",
          height: "100%",
          background: "radial-gradient(circle at 35% 35%, #c47d4f, #2f1507)",
          boxShadow: "inset 0 0 8px rgba(0,0,0,0.4)",
        }}
      />
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: "linear-gradient(135deg, rgba(255,255,255,0.18), transparent 55%)",
        }}
      />
    </div>
  );
}